import { Box, Button, Typography } from "@mui/material";
import { ReactComponent as CalendarIcon } from "../../assets/icons/calendar-colored.svg";
import { ReactComponent as BankIcon } from "../../assets/icons/bank-colored.svg";
import IconRowWithArrow from "../shared/IconRowWithArrow";
import AmountLargeBox from "../shared/AmountLargeBox";
import {
  getDirectDebitPeriodTitle,
  dateObjectToJalaali,
} from "../../utils/Utils";
import { DirectDebitStatusType } from "../../types/DirectDebitTypes";
import { useNavigate } from "react-router-dom";
import ErrorMessageText from "../shared/ErrorMessageText";

function EditSubscriptionBox({ sx = [], ...props }) {
  const { editableSubscription, serverSubscription, errorMessage } = props;
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
      }}
    >
      <AmountLargeBox
        error={!!errorMessage}
        amount={editableSubscription.amount}
        onClick={() => {
          navigate("set-amount");
        }}
      />
      <ErrorMessageText errorMessage={errorMessage} sx={{ mt: 1 }} />
      {serverSubscription?.status === DirectDebitStatusType.ACTIVE && (
        <Typography
          align="center"
          mt={"8px"}
          variant="subtitle1"
          color="primary.main"
        >
          {`${getDirectDebitPeriodTitle(
            serverSubscription
          )} / فعال از ${dateObjectToJalaali(serverSubscription?.createdAt)}`}
        </Typography>
      )}
      <Typography mt={"28px"} variant="h5" color="grey.2">
        تنظیمات پس‌انداز خودکار
      </Typography>
      {[
        {
          title: "بازه زمانی",
          icon: CalendarIcon,
          value: getDirectDebitPeriodTitle(editableSubscription),
          valueColor: "primary.main",
          action: () => {
            navigate("set-period");
          },
        },
        {
          title: "بانک",
          icon: BankIcon,
          valueColor: editableSubscription.bank && "primary.main",
          value: editableSubscription.bank?.name || "انتخاب کنید",
          action: () => {
            navigate("set-bank");
          },
        },
      ].map((item) => {
        return (
          <Box mt={3} key={item.title}>
            <IconRowWithArrow
              title={item.title}
              icon={item.icon}
              value={item.value}
              valueColor={item.valueColor}
              iconColor={"grey.4"}
              onClick={item.action}
            />
          </Box>
        );
      })}
    </Box>
  );
}

export default EditSubscriptionBox;
